"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const dialog_niuniu_png_1 = tslib_1.__importDefault(require("../../assets/images/dialog_niuniu.png"));
const i18n_1 = tslib_1.__importDefault(require("../../../i18n"));
// Props 定义
const __sfc_main = {};
__sfc_main.props = {
    visible: {
        key: "visible",
        required: true,
        type: Boolean
    }
};
__sfc_main.setup = (__props, __ctx) => {
    // Emits 定义
    const emit = __ctx.emit;
    /**
     * 确认取消
     */
    const handleConfirm = () => {
        emit('confirm');
        emit('update:visible', false);
    };
    /**
     * 取消操作
     */
    const handleCancel = () => {
        emit('cancel');
        emit('update:visible', false);
    };
    return {
        niuniuImg: dialog_niuniu_png_1.default,
        $t: i18n_1.default,
        handleConfirm,
        handleCancel
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2FuY2VsQ29uZmlybURpYWxvZy52dWUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJDYW5jZWxDb25maXJtRGlhbG9nLnZ1ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFnQ0Esc0dBQThEO0FBQzlELGlFQUErQjtBQUUvQixXQUFXO0FBQ1gsTUFBTSxVQUFVLEdBQUcsRUFBRSxDQUFDO0FBQ3RCLFVBQVUsQ0FBQyxLQUFLLEdBQUc7SUFDakIsT0FBTyxFQUFFO1FBQ1AsR0FBRyxFQUFFLFNBQVM7UUFDZCxRQUFRLEVBQUUsSUFBSTtRQUNkLElBQUksRUFBRSxPQUFPO0tBQ2Q7Q0FDRixDQUFDO0FBQ0YsVUFBVSxDQUFDLEtBQUssR0FBRyxDQUFDLE9BQU8sRUFBRSxLQUFLLEVBQUUsRUFBRTtJQUNwQyxXQUFXO0lBQ1gsTUFBTSxJQUFJLEdBQUcsS0FBSyxDQUFDLElBQUksQ0FBQztJQUV4Qjs7T0FFRztJQUNILE1BQU0sYUFBYSxHQUFHLEdBQUcsRUFBRTtRQUN6QixJQUFJLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDaEIsSUFBSSxDQUFDLGdCQUFnQixFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQ2hDLENBQUMsQ0FBQztJQUVGOztPQUVHO0lBQ0gsTUFBTSxZQUFZLEdBQUcsR0FBRyxFQUFFO1FBQ3hCLElBQUksQ0FBQyxRQUFRLENBQUMsQ0FBQztRQUNmLElBQUksQ0FBQyxnQkFBZ0IsRUFBRSxLQUFLLENBQUMsQ0FBQztJQUNoQyxDQUFDLENBQUM7SUFDRixPQUFPO1FBQ0wsU0FBUyxFQUFULDJCQUFTO1FBQ1QsRUFBRSxFQUFGLGNBQUU7UUFDRixhQUFhO1FBQ2IsWUFBWTtLQUNiLENBQUM7QUFDSixDQUFDLENBQUM7QUFDRixrQkFBZSxVQUFVLENBQUMifQ==